import React, { useEffect } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View,Linking } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';
import CImage from "../../common/CImage";
import * as RootNavigation from "../../utilities/RootNavigation"
import { FONTS, COLORS } from "../../constant";
import useStyles from "./LoginMobileContent_Styles";
const isSmallDevice = Dimensions.get('window').width < 767

export default function LoginMoibleContent(props) {
    const styles = useStyles();


    return (
        <View>
            <View style={styles.mobileFirstForwardViewStyle}>
                <Text style={styles.keepMvngTextStyle}>{"IDFC FIRST Bank"}</Text>
                <Text style={styles.forwardTextStyle}>{"FASTag"}</Text>
            </View>
            <Text style={styles.oneFastagTextStyle}>{"Keep moving forward"}</Text>
            <View style={styles.viewStyle1}>
                <TouchableOpacity
                    onPress={() => RootNavigation.navigate("SelectUnlockScreen")}
                    style={{
                        paddingTop: 10,
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: "10%",
                    }}
                >
                    <Text style={styles.activateUserTextStyle}>
                        {"Activate/Unlock User ID"}
                    </Text>
                    <CImage.RightArrowSmall></CImage.RightArrowSmall>
                </TouchableOpacity>
                <TouchableOpacity
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: "10%",
                        paddingTop: 10,
                    }}
                    onPress={() => {
                        RootNavigation.navigate("CheckTagBalance")
                    }}
                >
                    <Text style={styles.checkTagBalanceTextStyle}>
                        {"Check Tag balance"}
                    </Text>
                    <CImage.RightArrowSmall></CImage.RightArrowSmall>
                </TouchableOpacity>
                <View>
                    <TouchableOpacity onPress={() => Linking.openURL("https://play.google.com/store/apps/details?id=com.idfc.etoll&hl=en_IN&gl=US")}>

                        <CImage.PlaystoreIconMobile></CImage.PlaystoreIconMobile>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => Linking.openURL("https://apps.apple.com/in/app/idfc-first-bank-fastag/id1547409154")} style={{ marginTop: "-10%", paddingLeft: 32 }}>

                        <CImage.AppstoreIconMobile></CImage.AppstoreIconMobile>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.whatsupTextLink} onPress={()=>Linking.openURL("https://api.whatsapp.com/send?phone=919555555555&text=FASTag")}>
                      <CImage.WhatsAppIcon></CImage.WhatsAppIcon>
                      <Text style={styles.whatsupText}>{"Chat with us on WhatsApp"}</Text>
                  </TouchableOpacity>
                </View>
               
                <Image
                source={require("../../assets/images/maskGroup1.png")}
                style={styles.carImageStyle}
            />
            </View>
        </View>
    );
}


